import { showNotification } from '@/plugins/notification';
import { authErrorHandler } from '@/services/error/authHandler.js';

export default {
  async fetchOrgTypes({ commit }) {
    const response = await fetch(`/api/organization-types`);
    let data = await response.json();
    commit('setOrgTypes', data);
  },

  async fetchOrgData({ commit }, id) {
    const response = await fetch(`/api/organizations/${id}`);
    let data = await response.json();
    commit('setOrgData', data);
    return response;
  },

  async clearOrgData({ commit }, id) {
    let data = {};
    commit('setOrgData', data);
  },

  async fetchNumFollowersChannel({ commit }, id) {
    const response = await fetch(`/api/channels/${id}`);
    let data = await response.json();
    commit('setNumFollowersChannel', data.numFollowers);
  },

  async fetchOnlyUserOrgs({ commit }, params = {}) {
    const queryParams = new URLSearchParams({
      limit: '100',
      ...(params.search ? { search: params.search } : {}),
    }).toString();
    const response = await fetch(`/api/organizations/my?${queryParams}`);
    let data = await response.json();
    commit('setMyOrgList', data.results);
  },

  async fetchOtherOrgs({ commit }, params = {}) {
    const search = params.search || '';
    const queryParams = new URLSearchParams({
      limit: '100',
    });

    // Если запрос начинается с @, используем автодополнение
    if (search.startsWith('@')) {
      const cleanSearch = search.substring(1);
      queryParams.set('search', cleanSearch);
      queryParams.set('autocomplete', 'true');
    } else if (search) {
      queryParams.set('search', search);
    }

    const response = await fetch(`/api/organizations/other?${queryParams.toString()}`);
    let data = await response.json();
    commit('setOtherOrgList', data.results);
  },

  async fetchProfOrgByCode({ commit }, code) {
    const response = await fetch(`/api/organizations/by-code/${code}`);
    let data = await response.json();
    if (data.statusCode) {
      showNotification('error', `Error`, data.message, 7000);
    } else {
      commit('setOrgData', data);
    }
    return response;
  },

  async fetchCreateOrg({ commit }, payload) {
    let response = await fetch(`/api/organizations`, {
      method: 'POST',
      body: JSON.stringify({
        isPrivate: payload.isPrivate.value,
        name: payload.name,
        username: payload.username,
        email: payload.email,
        description: payload.description,
        typeId: payload.typeId,
        avatarFileId: payload.avatarFileId,
        terms: payload.terms,
      }),
      headers: {
        'Content-Type': 'application/json',
      },
    });
    let data = await response.json();
    if (data.statusCode) {
      showNotification('error', `Error`, data.message, 7000);
    } else {
      commit('setOrgData', data);
    }
    return response;
  },

  async fetchUpdateOrg({ commit }, payload) {
    let response = await fetch(`/api/organizations/${payload.orgId}`, {
      method: 'PATCH',
      body: JSON.stringify({
        isPrivate: payload.isPrivate ? payload.isPrivate.value : undefined,
        name: payload.name ? payload.name : undefined,
        // username: payload.username ? payload.username : undefined,
        email: payload.email ? payload.email : undefined,
        description: payload.description ? payload.description : undefined,
        typeId: payload.typeId ? payload.typeId : undefined,
        avatarFileId: payload.avatarFileId ? payload.avatarFileId : undefined,
        terms: payload.terms ? payload.terms : undefined,
      }),
      headers: {
        'Content-Type': 'application/json',
      },
    });
    let data = await response.json();
    if (data.statusCode) {
      showNotification('error', `Error`, data.message, 7000);
    } else {
      if (payload.type !== 'edit') {
        showNotification('success', `Success`, 'Group has been created', 7000);
      } else {
        showNotification('success', `Success`, 'Group has been updated', 7000);
      }
    }
    return response;
  },

  async fetchAddUser({ commit }, payload) {
    let response = await fetch(`/api/organizations/${payload.orgId}/invite-member`, {
      method: 'POST',
      body: JSON.stringify({
        userId: payload.userId,
        role: payload.role.value,
        hidden: payload.hidden,
      }),
      headers: {
        'Content-Type': 'application/json',
      },
    });
    let data = await response.json();
    if (data.statusCode) {
      showNotification('error', `Error`, data.message, 7000);
    } else {
      commit('setOrgData', data);
      showNotification('success', `Success`, 'Member has been added.', 7000);
    }
    return response;
  },

  async fetchUpdateUser({ commit }, payload) {
    let response = await fetch(`/api/organizations/${payload.orgId}/edit-member`, {
      method: 'POST',
      body: JSON.stringify({
        userId: payload.userId,
        role: payload.role,
        hidden: payload.hidden,
      }),
      headers: {
        'Content-Type': 'application/json',
      },
    });
    let data = await response.json();
    if (data.statusCode) {
      showNotification('error', `Error`, data.message, 7000);
    } else {
      commit('setOrgData', data);
      if (payload.type === 'display') {
        showNotification(
          'success',
          `Profile visibility`,
          "This member's role visibility on their profile has been successfully updated.",
          7000,
        );
      } else {
        showNotification('success', `Role updated`, "This member's role has been successfully changed.", 7000);
      }
    }
    return response;
  },

  async fetchAcceptInvite({ commit }, id) {
    let response = await fetch(`/api/organizations/${id}/accept-invitation`, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
    });
    let data = await response.json();
    if (data.statusCode) {
      showNotification('error', `Error`, data.message, 7000);
    } else {
      showNotification('success', `Success`, 'Member has been added.', 7000);
    }
    return response;
  },

  async fetchDeclineInvite({ commit }, id) {
    let response = await fetch(`/api/organizations/${id}/decline-invitation`, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
    });
    let data = await response.json();
    if (data.statusCode) {
      showNotification('error', `Error`, data.message, 7000);
    } else {
      showNotification('success', `Success`, 'Invitation has been declined.', 7000);
    }
    return response;
  },

  async fetchCancelInvite({ commit }, payload) {
    let response = await fetch(`/api/organizations/${payload.id}/cancel-invitation`, {
      method: 'POST',
      body: JSON.stringify({
        userId: payload.userId,
      }),
      headers: {
        'Content-Type': 'application/json',
      },
    });
    let data = await response.json();
    if (data.statusCode) {
      showNotification('error', `Error`, data.message, 7000);
    } else {
      showNotification('success', `Success`, 'Invitation has been canceled.', 7000);
    }
    return response;
  },

  async fetchDeleteMember({ commit }, payload) {
    let response = await fetch(`/api/organizations/${payload.id}/remove-member`, {
      method: 'POST',
      body: JSON.stringify({
        userId: payload.userId,
      }),
      headers: {
        'Content-Type': 'application/json',
      },
    });
    let data = await response.json();
    if (data.statusCode) {
      showNotification('error', `Error`, data.message, 7000);
    } else {
      showNotification('success', `Success`, 'Member has been deleted.', 7000);
    }
    return response;
  },

  async fetchSearchMembers({ commit }, query) {
    if (query.trim().length < 2 && query !== '') {
      commit('setSearchMembers', []);
      commit('setNoSearchMembers', null);
      return;
    }
    try {
      let users = [];
      let originalQuery = query;
      if (query.startsWith('@')) {
        const cleanQuery = query.substring(1);
        const userParams = new URLSearchParams({ search: cleanQuery, autocomplete: 'true' });
        if (!cleanQuery || cleanQuery === '') {
          return;
        }
        const userResponse = await fetch(`/api/users?${userParams}`);
        const userData = await userResponse.json();
        users = Array.isArray(userData) ? userData : userData.results || [];
      } else {
        const params = new URLSearchParams({ query });
        const response = await fetch(`/api/search?${params}`);
        const data = await response.json();
        users = Array.isArray(data) ? data.filter(item => item.collection === 'users').map(item => item.render) : [];
      }
      // Если ничего не найдено, пробуем с @
      if (!users.length && !query.startsWith('@')) {
        const cleanQuery = query;
        const userParams = new URLSearchParams({ search: cleanQuery, autocomplete: 'true' });
        const userResponse = await fetch(`/api/users?${userParams}`);
        const userData = await userResponse.json();
        users = Array.isArray(userData) ? userData : userData.results || [];
      }
      // Filter unique users by id
      const uniqueUsers = [];
      const seenIds = new Set();
      for (const user of users) {
        if (!seenIds.has(user.id)) {
          uniqueUsers.push(user);
          seenIds.add(user.id);
        }
      }
      commit('setSearchMembers', uniqueUsers);
      if (!uniqueUsers.length) {
        commit('setNoSearchMembers', originalQuery);
      } else {
        commit('setNoSearchMembers', null);
      }
    } catch (error) {
      console.error('Error fetching search results:', error);
      commit('setSearchMembers', []);
      commit('setNoSearchMembers', null);
    }
  },

  async fetchFollowChannel({ commit }, payload) {
    let response = await fetch(`/api/users/follow-channel`, {
      method: 'POST',
      body: JSON.stringify({
        channelId: payload.channelId,
        followType: payload.followType,
      }),
      headers: {
        'Content-Type': 'application/json',
      },
    });
    let data = await response.json();
    if (data.statusCode) {
      showNotification('error', `Error`, data.message, 7000);
    } else {
      if (payload.followType === 'follow') {
        showNotification(
          'success',
          `Success`,
          'You are now following this group. Its posts will appear in your Following feed.',
          7000,
        );
      } else {
        showNotification(
          'success',
          `Success`,
          'You are now monitoring this group. Its posts will appear in your Monitoring feed.',
          7000,
        );
      }
    }
    return response;
  },

  async fetchUnFollowChannel({ commit }, payload) {
    let response = await fetch(`/api/users/unfollow-channel`, {
      method: 'POST',
      body: JSON.stringify({
        channelId: payload.channelId,
      }),
      headers: {
        'Content-Type': 'application/json',
      },
    });
    let data = await response.json();
    if (data.statusCode) {
      showNotification('error', `Error`, data.message, 7000);
    } else {
      showNotification(
        'success',
        `Success`,
        'You have unfollowed this group. Its posts will no longer appear in your feeds.',
        7000,
      );
    }
    return response;
  },

  async fetchOrgPosts({ commit, state }, { id, limit, channel }) {
    // Если загрузка уже идет, не делаем повторный запрос
    if (state.isLoading) {
      return;
    }

    // Сначала устанавливаем признак загрузки
    commit('setStatusLoad', true);

    try {
      // Очищаем коллекцию перед загрузкой
      commit('setOrgPosts', []);

      const params = new URLSearchParams({
        limit: limit || '15',
        channelId: channel ? channel.id : id,
      }).toString();
      let response = await fetch(`/api/posts?${params}`);
      let posts = await response.json();

      if (posts.statusCode) {
        authErrorHandler(posts);
      }

      if (posts.count > 0) {
        commit('setOrgPosts', posts.results);
      }

      return posts;
    } catch (error) {
      console.error('Error fetching organization posts:', error);
      return { results: [], count: 0 };
    } finally {
      // В любом случае снимаем признак загрузки
      commit('setStatusLoad', false);
    }
  },

  async fetchDeleteOrg({ commit }, id) {
    let response = await fetch(`/api/organizations/${id}`, {
      method: 'DELETE',
      headers: {
        'Content-Type': 'application/json',
      },
    });
    if (!response.ok) {
      showNotification('error', `Error`, data.message, 7000);
    } else {
      showNotification('success', `Success`, 'The group has been successfully deleted.', 7000);
    }
    return response;
  },

  async fetchJoinRequests({ commit }, id) {
    let response = await fetch(`/api/organizations/${id}/join-requests`, {
      method: 'GET',
      headers: {
        'Content-Type': 'application/json',
      },
    });
    let data = await response.json();
    if (data.statusCode) {
      showNotification('error', `Error`, data.message, 7000);
    } else {
      commit('setJoinRequests', data);
    }
  },

  async fetchRequestToJoin({ commit }, id) {
    let response = await fetch(`/api/organizations/${id}/request-to-join`, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
    });
    let data = await response.json();
    if (data.statusCode) {
      showNotification('error', `Error`, data.message, 7000);
    } else {
      showNotification('success', `Request sent`, 'Your request to join this group has been submitted.', 7000);
    }
    return response;
  },

  async fetchLeaveOrg({ commit }, id) {
    let response = await fetch(`/api/organizations/${id}/leave`, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
    });
    let data = await response.json();
    if (data.statusCode) {
      showNotification('error', `Error`, data.message, 7000);
    } else {
      showNotification(
        'success',
        `Left group`,
        "You have been removed from the group's member list and no longer have access to member-specific features.",
        7000,
      );
    }
    return response;
  },

  async fetchAcceptJoinRequest({ commit }, payload) {
    let response = await fetch(`/api/organizations/${payload.channelId}/accept-join-request`, {
      method: 'POST',
      body: JSON.stringify({
        userId: payload.userId,
      }),
      headers: {
        'Content-Type': 'application/json',
      },
    });
    let data = await response.json();
    if (data.statusCode) {
      showNotification('error', `Error`, data.message, 7000);
    } else {
      showNotification(
        'success',
        `Request approved`,
        "The user has been approved and is now part of the group's member list.",
        7000,
      );
    }
    return response;
  },
};
